import { AnalyticsParams } from "../constants/params";

/**
 * @param {{ type?: string } | null} teamA
 * @param {{ type?: string } | null} teamB
 */
export function resolveMatchType(teamA, teamB) {
  const t = teamA?.type || teamB?.type;
  if (t === "doubles") return "doubles";
  return "singles";
}

/**
 * @param {object} [options]
 * @param {number} [options.bestOf]
 * @param {boolean} [options.isPrivate]
 * @param {'referee'|'spectator'} [options.role]
 * @param {{ type?: string }} [options.teamA]
 * @param {{ type?: string }} [options.teamB]
 */
export function buildMatchContextParams(options = {}) {
  const params = {};
  if (options.teamA || options.teamB) {
    params[AnalyticsParams.MATCH_TYPE] = resolveMatchType(
      options.teamA,
      options.teamB
    );
  }
  if (options.bestOf != null) {
    params[AnalyticsParams.BEST_OF] = options.bestOf;
  }
  if (options.isPrivate != null) {
    params[AnalyticsParams.IS_PRIVATE] = Boolean(options.isPrivate);
  }
  if (options.role) {
    params[AnalyticsParams.ROLE] = options.role;
  }
  return params;
}

/**
 * Map internal winner side to analytics-safe value.
 * @param {'A'|'B'|string|null|undefined} side
 */
export function winnerSideParam(side) {
  if (side === "A") return "side_a";
  if (side === "B") return "side_b";
  return undefined;
}
